export default __webpack_public_path__ + "static/media/blank.770aeebe.jpg";